// extracted by mini-css-extract-plugin
export default {"areaFestival":"index_areaFestival_FNZZp","navBar":"index_navBar_CJkOg","header":"index_header_TJYJC","areaReports":"index_areaReports_9ZLqA","scene":"index_scene_4fcad"};